import { Phone, MapPin, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink-900 text-sand-50 pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-5">
            <p className="overline !text-gold">Est. 1984 · Mississauga</p>
            <p className="mt-4 font-serif text-3xl lg:text-4xl leading-tight max-w-md">
              Where every strand <span className="italic text-gold">tells a story.</span>
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase text-sand-300/70">Visit</p>
            <p className="mt-3 font-serif text-xl leading-snug">
              1900 Dundas St W<br />Mississauga, ON L5K 1P9
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.2em] uppercase text-sand-300/70">Call</p>
            <a
              href="tel:+19058222690"
              data-testid="footer-phone"
              className="mt-3 block font-serif text-xl hover:text-gold transition-colors"
            >
              (905) 822-2690
            </a>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.2em] uppercase text-sand-300/70">Follow</p>
            <a
              href="https://www.instagram.com/flavioshairdesign/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="mt-3 inline-flex items-center gap-2 font-serif text-xl hover:text-gold transition-colors"
            >
              <Instagram className="w-5 h-5" /> @flavioshairdesign
            </a>
          </div>
        </div>

        {/* Big brand text */}
        <div className="border-t border-sand-50/10 pt-16">
          <img
            data-testid="footer-wordmark"
            src="/flavios-logo-light.png"
            alt="Flavio's"
            className="w-full max-w-[320px] lg:max-w-[440px] h-auto object-contain"
          />
        </div>

        {/* Bottom */}
        <div className="mt-16 flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-xs tracking-[0.15em] uppercase text-sand-300/60">
          <p>© {new Date().getFullYear()} Flavio&apos;s House of Hair Design — All Rights Reserved.</p>
          <div className="flex flex-wrap gap-6">
            <span className="inline-flex items-center gap-2">
              <Phone className="w-3.5 h-3.5" /> (905) 822-2690
            </span>
            <span className="inline-flex items-center gap-2">
              <MapPin className="w-3.5 h-3.5" /> Mississauga, ON
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
